import React, { useEffect, useContext } from 'react'
import ScrollToTop from '../../../Shared/ScrollToTop';
import { NavLink } from 'react-router-dom';
import DashboardImg from './../../../../assets/images/weerp/web-image/business/dashboard.png';
import { ProjectTypeContext } from '../../../../ContextHandle';
export default function Dashboard({ setActivePage, sectionRefs, setDefaultWebActiveMenu }) {
 /* eslint-disable */
    var projectType = useContext(ProjectTypeContext);
    const panelName   = 'Admin panel';
    const projectName = projectType.projectName;
    projectType = projectType.projectType;
    useEffect(() => {
        setActivePage(1008);
        document.title = 'Dashboard | ' + projectName + ' web';
        setDefaultWebActiveMenu(2);
    }, [projectName]);

    return (
        <div className='d-flex flex-column justify-content-between doc-page'>
            <ScrollToTop></ScrollToTop>
            <div className=" right-content-box-width">
                <nav >
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a href={`/${projectType}/introduction`}><i className='fa fa-home'></i></a></li>
                        <li className="breadcrumb-item" aria-current="page">{panelName}</li>
                        <li className="breadcrumb-item active" aria-current="page">Dashboard</li>
                    </ol>
                </nav>
                <div id="dashboards" ref={sectionRefs['4']}>
                    <h4 className="font-weight-bold mt-5  ">Dashboard</h4>
                    <p className="pt-3">You can see the total summary on the dashboard.</p>
                    <p><strong>Sales:</strong> Total Sales, Payments and Dues. </p>
                    <p><strong>POS:</strong> How many sales have been made through POS, how many payments have been made and how many dues are there.</p>
                    <p><strong>Purhcase:</strong> You can also see how much money has been purchased, how much payment has been made and how much is due.</p>
                    <p><strong>Purhcase Return:</strong> How much money has the purchase returned, how much money has been backed and how much money is due. </p>
                    <p>Last 30 days of sales analytics charts will be displayed. also Last 30 days of POS sales analytics charts will be displayed. A list of recent sales and POS sales list will be displayed. </p>
                    <div className='pt-3'>
                        <img src={DashboardImg} className="w-100 rounded" alt="Dashboard"></img>
                    </div>
 
                </div>

                <div className="d-flex justify-content-between border-top mt-5">
                    <div className="text-start mt-4">
                        <NavLink to={`/${projectType}/forgot-password`} className="text-decoration-none">
                            <a href='/' className="mb-0 text-decoration-none text-secondary">Previous <i className="bi bi-caret-left" /></a>
                            <h4 className='pagination-title'>Forgot password</h4>
                        </NavLink>
                    </div>
                    <div className="text-end my-2">
                        <NavLink to={`/${projectType}/admin/profile`} className="text-decoration-none">
                            <a href="#login" id="quickStartGuide" className="mb-0 text-decoration-none text-secondary">Next <i className="bi bi-caret-right" /></a>
                            <h4 className='pagination-title'>Profile</h4>
                        </NavLink>
                    </div>
                </div>
            </div>
        </div>
    )
}
